<h1 mat-dialog-title>Finalise Changeover</h1>
<div mat-dialog-content>
  <p>
    Are you sure you want to finalise this changeover?
  </p>
  <div *ngIf="this.model.ongoingTasks.length > 0">
    The following ongoing task(s) will be automatically stopped:
    <ul *ngFor="let task of this.model.ongoingTasks">
      <li>{{task.name}}</li>
    </ul>
  </div>
  <div *ngIf="this.model.tasksWithNotesNeeded.length > 0">
    Please consider adding a note to the following task(s):
    <ul *ngFor="let taskName of this.model.tasksWithNotesNeeded">
      <li>{{taskName}}</li>
    </ul>
  </div>
  <div class="error" *ngIf="this.errorMessage">{{this.errorMessage}}</div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close
          [disabled]="this.isBusy">NO</button>
  <button mat-button
          [disabled]="this.isBusy"
          (click)="this.onSubmit()">
          <mat-spinner *ngIf="this.isBusy" diameter="28"></mat-spinner>
          <span *ngIf="!this.isBusy">YES</span>
        </button>
</div>